import script from "./Custom.vue?vue&type=script&setup=true&lang=ts"
export * from "./Custom.vue?vue&type=script&setup=true&lang=ts"

import "./Custom.vue?vue&type=style&index=0&id=826a4e2e&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-826a4e2e"]])

export default __exports__